import { Sport } from '__generated__/globalTypes';

import {
  ConversionCreditWithAmounts,
  useConversionCredits,
} from './useConversionCredits';

export const useConversionCredit = (
  sport?: Sport
): ConversionCreditWithAmounts | undefined => {
  const { conversionCredits } = useConversionCredits({
    sport,
  });

  return conversionCredits?.[0];
};
